import styled from 'styled-components';
import { spacing, fontSizes } from 'ui/theme';

export const StyledUserListWrapper = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
align-self: stretch;
`;

export const StyledAudience = styled.div`
font-size: ${fontSizes.s18};
font-weight: 700;
line-height: ${fontSizes.s20};
`;
export const StyledRecipient = styled.div`
font-size: ${fontSizes.s12};
font-style: normal;
font-weight: 400;
line-height: ${fontSizes.s16};
letter-spacing: 0.1px;
display: flex;
align-items: center;
gap: ${spacing.quarter};
`;
